import * as Sentry from "@sentry/react";

const captureException = (error) => {
    const err = error instanceof Error ? error : new Error(String(error));
    Sentry.captureException(err);
}

const captureMessage = (msg) => {
    Sentry.captureMessage(msg);
}

export const MonitorService = {
    captureMessage,
    captureException,
}